import styles from "./AnalyticsFilters.module.scss";
import { AnalyticsFilterControls, PERIOD_OPTIONS, PLATFORM_OPTIONS } from "./useAnalyticsFilters";
import { Select } from "../../../../pages/customer/components";

type Props = AnalyticsFilterControls & {
	/**
	 * The page's widgets do not read these yet, so the row stays in place — it is where
	 * the filters belong once the endpoints land — but cannot be operated to no effect.
	 * Delete the prop at the call site when the page is wired up.
	 */
	disabled?: boolean;
};

/** The utility / platform / period row every analytics page is scoped by. */
const AnalyticsFilters = ({
	utility,
	setUtility,
	platform,
	setPlatform,
	period,
	setPeriod,
	utilityOptions,
	disabled = false,
}: Readonly<Props>) => (
	<div className={styles.filters}>
		<Select
			className={styles.filter}
			variant="light"
			options={utilityOptions}
			value={utility}
			onChange={setUtility}
			disabled={disabled}
		/>
		<Select
			className={styles.filter}
			variant="light"
			options={PLATFORM_OPTIONS}
			value={platform}
			onChange={setPlatform}
			disabled={disabled}
		/>
		<Select
			className={styles.filter}
			variant="light"
			options={PERIOD_OPTIONS}
			value={period}
			onChange={setPeriod}
			disabled={disabled}
		/>
	</div>
);

export default AnalyticsFilters;
